import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
        <p className="text-gray-700 mb-4">
          At PostNudge, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your personal information when you use our Chrome extension and web application.
        </p>
        <p className="text-gray-700 mb-4 font-medium">
          We do not sell your data. Period.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Information We Collect</h2>
        <div className="text-gray-700 mb-4">
          <p className="mb-4">We only collect:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>Audio recordings you create through our application</li>
            <li>Basic authentication data from Google OAuth (email and name)</li>
            <li>Information you manually enter about yourself or your business</li>
          </ul>
        </div>
        <div className="bg-blue-50 p-4 rounded-lg mt-4">
          <p className="text-blue-800 font-medium">Important Note About LinkedIn:</p>
          <p className="text-blue-700 mt-2">
            We do not collect any data from LinkedIn. While our extension works with LinkedIn, we do not access, store, or process any of your LinkedIn profile data. Any business or profile information used in our service is manually entered by you.
          </p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">How We Use Your Information</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          <li>To process your audio recordings and generate content based on your input</li>
          <li>To authenticate your account using Google OAuth</li>
          <li>To provide you with our content generation service</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Data Storage and Security</h2>
        <p className="text-gray-700 mb-4">
          We use industry-standard security measures to protect your data. Your audio recordings and generated content are stored securely and are only accessible to you. We only retain the minimum necessary authentication data from Google OAuth to maintain your account.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">What We Don't Do</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          <li className="font-medium">We never sell your data to anyone</li>
          <li>We don't collect any LinkedIn profile data</li>
          <li>We don't track usage data or analytics</li>
          <li>We don't store authentication data beyond basic Google OAuth information</li>
          <li>We don't share your information with third parties</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Your Rights</h2>
        <p className="text-gray-700 mb-4">
          You have the right to:
        </p>
        <ul className="list-disc list-inside text-gray-700 space-y-2">
          <li>Request deletion of your account and all associated data</li>
          <li>Export your data</li>
          <li>Opt-out of any future communications</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
        <p className="text-gray-700 mb-4">
          If you have any questions about our Privacy Policy or how we handle your data, please contact us at privacy@postnudge.com
        </p>
      </section>

      <footer className="text-sm text-gray-600">
        <p>Last updated: February 16, 2025</p>
      </footer>
    </div>
  );
}
